<template>
    <div>
      <Login :page="currentPage" @changePage="changePage"></Login>
      <Register :page="currentPage" @changePage="changePage"></Register>
      <Home @changePage="changePage" v-if="currentPage === 'home'"></Home>
    </div>
</template>

<script>
import Login from "./components/Login"
import Register from "./components/Register"
import Home from "./components/home"

export default {
  components: {
    Login,
    Register,
    Home,
    
  },
  data() {
    return {
      currentPage: 'login',
    };
  },
  methods: {
    changePage(data){
      this.currentPage = data.page
    }
  },
  created: function(){
    if(localStorage.getItem('usertoken')){
      this.currentPage = 'home'
    }else{
      this.currentPage = 'login'
    }
  }
}
</script>